import React from 'react';
import { defaultListProps } from '~constants/config';
import { List, TextField, NumberField } from 'react-admin';
import CustomDatagrid from '~components/CustomDatagrid';
import ActionsField from '~components/ActionsField';
import IconButton from '@material-ui/core/IconButton';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import api from '~config/api';

function MoveButtons({ record }) {
  const handleMove = (direction) => {
    api.post(`/disclaimers/${record.id}/${direction}/`).then(() => {
      window.location.reload();
    });
  };

  return (
    <>
      <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleMove('move-up'); }}>
        <ArrowUpward fontSize="small" />
      </IconButton>
      <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleMove('move-down'); }}>
        <ArrowDownward fontSize="small" />
      </IconButton>
    </>
  );
}

function DisclaimerList({ ...props }) {
  return (
    <List {...defaultListProps} {...props} sort={{ field: 'order', order: 'ASC' }}>
      <CustomDatagrid rowClick="edit">
        <NumberField source="order" />
        <TextField source="titleEs" />
        <MoveButtons label="Orden" />
        <ActionsField />
      </CustomDatagrid>
    </List>
  );
}

export default DisclaimerList;
